export default "__VITE_ASSET__2c59d29d__"